export enum ECreativeUploadTitles {
  AGENT_PHOTO = 'Agent Photo',
  LISTING_PHOTO = 'Listing Photo',
  AGENCY_LOGO = 'Agency Logo',
}
